import {useMutation} from '@tanstack/react-query';

import {getAuthToken} from '@/shared/lib/localStorage/authToken';
import {getCookieConsentDto} from '@/shared/lib/localStorage/signUp/cookieConsent';

import {saveCookieConsent} from '../api/saveCookieConsent';

export function useSaveCookieConsent() {
  return useMutation({
    mutationFn: async () => {
      const token = getAuthToken();
      if (!token) {
        return;
      }
      const cookiesConsentDto = getCookieConsentDto();
      if (!cookiesConsentDto) {
        return;
      }

      await saveCookieConsent(cookiesConsentDto);
    },
  });
}
